import React from "react";
import { ConfigProvider, Popover, Tooltip } from "antd";
import { DefaultConversationAvatar, isAlphabet } from "./utils/CommonVessels";

const ConversationAvatar = ({ name, imageUrl, shouldRender, tooltipTitle, customClasses, messageOwnerDetails }) => {
  if (!shouldRender) return null;
  name = name || messageOwnerDetails?.firstName || messageOwnerDetails?.email;

  return (
    <div className={`d-flex align-items-center justify-content-center conversationAvatar text-capitalize ${customClasses || ""}`}>
      {imageUrl ? (
        <Tooltip title={name || tooltipTitle}>
          <img height={30} width={30} alt="avatar" src={imageUrl} style={{ borderRadius: 4, objectFit: "cover" }} />
        </Tooltip>
      ) : isAlphabet(name?.slice(0, 1)) ? (
        <Tooltip title={name || tooltipTitle}>{name?.slice(0, 1)}</Tooltip>
      ) : (
        <ConfigProvider
          theme={{
            components: {
              Popover: {
                colorBgElevated: "var(--hs-color-BlackRussian)",
                colorText: "var(--hs-plain-white)",
              },
            },
          }}
        >
          <Popover placement="top" content={name || tooltipTitle}>
            <span>
              <DefaultConversationAvatar />
            </span>
          </Popover>
        </ConfigProvider>
      )}
    </div>
  );
};

export default ConversationAvatar;
